import React, { useState } from "react";
import { Input, Select, Button } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { useAuth } from "../../hooks/useAuth";

interface FilterField {
  key: string;
  label: string;
  type: "text" | "select";
  options?: { value: string | number; label: string }[];
}

interface VendorFiltersProps {
  fields: FilterField[];
  onApplyFilters: (filters: Record<string, any>) => void;
  onClearFilters: () => void;
  canSeeAllLocations: boolean; // New prop for location permission
}

const VendorFilters: React.FC<VendorFiltersProps> = ({
  fields,
  onApplyFilters,
  onClearFilters,
  canSeeAllLocations,
}) => {
  const { data: user } = useAuth();
  const locationId = user?.location?.id;

  const [filters, setFilters] = useState<Record<string, any>>({
    location_id: canSeeAllLocations ? undefined : locationId,
  });

  const handleFilterChange = (key: string, value: any) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleClearFilters = () => {
    setFilters({
      location_id: canSeeAllLocations ? undefined : locationId,
    });
    onClearFilters();
  };

  return (
    <div className="bg-white p-4 shadow-md rounded-lg space-y-3">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {fields.map(({ key, label, type, options }) => (
          <div key={key}>
            {type === "text" && (
              <Input
                placeholder={label}
                value={filters[key] || ""}
                onChange={(e) => handleFilterChange(key, e.target.value)}
              />
            )}
            {type === "select" && (
              <Select
                placeholder={label}
                value={filters[key] || undefined}
                onChange={(value) => handleFilterChange(key, value)}
                className="w-full"
                options={options}
              />
            )}
          </div>
        ))}
      </div>

      <div className="flex justify-end space-x-3">
        <Button
          type="primary"
          icon={<FilterOutlined />}
          onClick={() => onApplyFilters(filters)}
        >
          Apply Filters
        </Button>
        <Button onClick={handleClearFilters}>Clear Filters</Button>
      </div>
    </div>
  );
};

export default VendorFilters;
